/**
 * PATH: apps/inventory/src/pages/ReportsPage.tsx
 * PURPOSE: Inventory reports
 */
import { EmptyRegister } from './emptyRegister'

export default function ReportsPage() {
  return (
    <EmptyRegister
      title="Reports"
      detail="No inventory reports are connected."
    />
  )
}
